import React from 'react'
import { Typography, TextField, Button, Grid, InputAdornment } from '@mui/material';
import IconsColor from '../../Utils/IconsColor';
import styles from "../../Styles/ComponentStyles/InflationCalculator/InflationCalculator.module.scss"
import GlobalButton from '../../Utils/GlobalUtilsComponents/GlobalButton';
import GlobalTextfield from '../../GlobalComponent/GlobalTextfield/GlobalTextfield';

interface AnnuityReturnRateInputPopupProps {
    value: string;
    onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
    onApply: () => void;
}

const MAX_RATE_PERCENT = 100;

const AnnuityReturnRateInputPopup = ({ value, onChange, onApply }: AnnuityReturnRateInputPopupProps) => {
    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const next = e.target.value;
        if (next === '') {
            onChange(e);
            return;
        }
        const num = parseFloat(next);
        if (!Number.isNaN(num) && num > MAX_RATE_PERCENT) {
            return;
        }
        onChange(e);
    };

    return (
        <>
            <Grid container padding={"15px 0px"} gap={3}>
                <Grid item xs={12}>
                    <Typography variant="subtitle2" sx={{ mb: 1, color: '#314158', alignSelf: 'flex-start', fontSize: "15px" }}>
                        Rate of Return
                    </Typography>
                    <GlobalTextfield
                        fullWidth={true}
                        size='small'
                        autoComplete='off'
                        // className={styles.inflationField}
                        value={value}
                        onChange={handleChange}
                        onKeyPress={(e: any) => {
                            if (!/[0-9.]$/.test(e.key)) {
                                e.preventDefault();
                            }
                        }}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <IconsColor iconName="percentageIcon" color="rgba(145, 145, 145, 1)" width="16px" height="16px" />
                                </InputAdornment>
                            ),
                        }}
                    />
                </Grid>
                <Grid item xs={12} container justifyContent="center">
                    <GlobalButton
                        value="Apply"
                        onClick={onApply}
                        disabled={!value}
                        className={styles.applyBtn}
                        sx={{
                            "&.Mui-disabled": {
                                opacity: "0.6 !important"
                            }
                        }}
                    />
                </Grid>
            </Grid>
        </>
        // </Box>
    );
};

export default AnnuityReturnRateInputPopup
